import * as React from "react";
import type { SVGProps } from "react";
const SvgFaceSad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 10c0 .55.45 1 1 1s1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1zM14 11c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1M14.1 15.42c.13.05.27.08.4.08l.01.01c.39 0 .76-.22.92-.6.22-.51-.01-1.1-.52-1.32l-.032-.012c-.217-.086-1.439-.568-2.868-.568-1.493 0-2.77.527-2.892.577l-.008.003a.99.99 0 0 0-.52 1.31c.22.5.81.73 1.31.52.01-.01.99-.42 2.1-.42s2.1.42 2.1.42"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0 5.51 4.49 10 10 10s10-4.49 10-10S17.51 2 12 2 2 6.49 2 12m2 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFaceSad;
